import { fetchAPI } from "../../../../../config/axios";
import {
  KuadranAction,
  KuadranActionType,
  KuadranDataModel,
} from "./types";

export const Kuadran: KuadranDataModel = {
  main: {
    data: [],
    total: 0,
  },
};

export const KuadranReducer = (
  state: KuadranDataModel = Kuadran,
  action: KuadranAction
): KuadranDataModel => {
  switch (action.type) {
    case KuadranActionType.GetKuadran:
      return { ...state, main: action.data };
    default:
      return state;
  }
};

export const KuadranCommand = {
  GetKuadran: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().get(
          "/tj-parameter-penilaian/kuadrans",
          { params }
        );
        dispatch({
          type: KuadranActionType.GetKuadran,
          data: {
            data: response.data.data.data,
            total: response.data.data.total,
          },
        });
      } catch (error) {
        throw error;
      }
    };
  },
  CreateKuadran: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().post(
          "/tj-parameter-penilaian/kuadran",
          body
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  UpdateKuadran: (body: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().patch(
          "/tj-parameter-penilaian/kuadran",
          body
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
  DeleteKuadran: (params: any) => {
    return async (dispatch: any) => {
      try {
        const response = await fetchAPI().delete(
          "/tj-parameter-penilaian/kuadran",
          { params }
        );
        return response;
      } catch (error) {
        throw error;
      }
    };
  },
};
